import { render } from "./open-wallet.vue?vue&type=template&id=767c1dd6&scoped=true"
import script from "./open-wallet.vue?vue&type=script&lang=js"
export * from "./open-wallet.vue?vue&type=script&lang=js"

import "./open-wallet.vue?vue&type=style&index=0&id=767c1dd6&lang=scss&scoped=true"

import exportComponent from "/builds/x3-web/pc/pc-yunxiao/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-767c1dd6"]])

export default __exports__